<div id="layout">
    <div>
        <div id="header">
            <app-menu *ngIf="router.url !== '/erreur404'"></app-menu>
        </div>
        <div id="main">
            <router-outlet></router-outlet>
            <!-- « chargement-flottant » sort le loader du flux (voir le .scss).
                 Tant qu'il était un bloc ordinaire, il occupait le haut de la page
                 vide, puis GLISSAIT vers le bas quand le contenu s'insérait
                 au-dessus de lui, puis laissait un trou en disparaissant : trois
                 décalages de mise en page pour un simple indicateur d'attente. -->
            <div *ngIf="loading" class="container my-5 chargement-flottant">
                <app-loader></app-loader>
            </div>
        </div>
    </div>
    <div id="footer">
        <app-footer *ngIf="router.url !== '/erreur404'"></app-footer>
    </div>
</div>
